import { UserStatus } from "../../../components/user/UserStatus";

export enum UserGroup {
  SYSTEM_ADMINISTRATOR = "SYSTEM_ADMINISTRATOR",
  USER_ADMINISTRATOR = "USER_ADMINISTRATOR",
  PROGRAM_ADMINISTRATOR = "PROGRAM_ADMINISTRATOR",
  PROGRAM_ANALYST = "PROGRAM_ANALYST",
  CUSTOMER_SERVICE_AGENT = "CUSTOMER_SERVICE_AGENT",
  SALES_PERSON = "SALES_PERSON",
  KNISTR_ADMINISTRATOR = "KNISTR_ADMINISTRATOR",
  KNISTR_CUSTOMER_SUCCESS = "KNISTR_CUSTOMER_SUCCESS",
}

export interface OTPDevice {
  id: string;
  userLabel: string;
  createdDate: string;
}

export interface UserDto {
  firstName: string;
  lastName: string;
  userNumber?: string;
  mailAddress?: string;
  password?: string;
  userName?: string;
  externalUnitNumber?: string;
  userGroups: UserGroup[];
  lastAccess?: string;
  status: UserStatus;
  otpDevices?: OTPDevice[];
}
